<template>
  <v-container class="metric-insight-layout pl-0 pr-0" fill-height fluid>
    <v-layout fill-height fluid column space-between align-center>
      <BorderedTabs :settings="tabSettings"></BorderedTabs>
      <Filters></Filters>
      <router-view :key="$route.path"></router-view>
    </v-layout>
  </v-container>
</template>

<script>
import BorderedTabs from '@/components/BorderedTabs'
import routes from '@/route_names'
import Filters from '@/components/insights/Filters'

export default {
  name: 'BaseView',
  mixins: [
    {
      computed: {
        routes: function() {
          return routes
        }
      }
    }
  ],
  components: {
    BorderedTabs,
    Filters
  },
  props: {
    tabSettings: { type: Object }
  },
  created: function() {},
  data: function() {
    return {
      route: this.$router.currentRoute.name,
      loading: true,
      brandTitle: this.$store.getters['user/currentCampaign'].brand_name,
      questions: [],
      campaign: this.$store.getters['user/currentCampaign']
    }
  },
  methods: {
    save() {},
  },
  watch: {
    $route: function(to, from) {

    }
  }
}
</script>

<style lang="stylus">
.metric-insight-layout {
    position relative
    .filter-area {
        position absolute
        right 0px
        top: 25px
    }
}
</style>
